/**
 * Axios initialization for application.
 *
 */

import INSTANCE from '@/utils/axios-config';
import { AxiosError } from 'axios';
import siteModule from '@/store/site';

INSTANCE.interceptors.request.use(undefined, (error: AxiosError) => {
    siteModule.fetchApiRequestError(error);

    return Promise.reject(error);
});

INSTANCE.interceptors.response.use(undefined, (error: AxiosError) => {
    siteModule.fetchApiResponseError(error);

    return Promise.reject(error);
});

export default INSTANCE;
